import React from 'react'
import PropTypes from 'prop-types'
import { useField, ErrorMessage } from 'formik'

// Shared Styled Elements
import { Wrapper, FormLabel, FormErrorMessage } from '../SharedStyles.element'

// Styled Elements
import { FormTextFieldInput } from './FormTextField.elements'

function FormTextField(props) {
  // Destructure
  const { type, label, disabled, ...rest } = props

  // Hooks
  const [fields] = useField(props)

  return (
    <Wrapper label={label}>
      {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
      <FormTextFieldInput disabled={disabled} type={type} {...fields} {...rest} />
      <FormErrorMessage>
        <ErrorMessage {...fields} />
      </FormErrorMessage>
    </Wrapper>
  )
}

// Default Props
FormTextField.defaultProps = {
  type: '',
  label: '',
  disabled: false,
}

// Proptypes Validation
FormTextField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FormTextField
